import {
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  MenuItem,
  Paper,
  List,
  ListItem,
  Tooltip,
  Divider,
  Stack,
  CardContent,
  Chip,
  ChipProps,
} from "@mui/material";
import { useStyles } from "../../../theme/appStyles";
import React, { useEffect, useMemo, useState } from "react";
import { CircularProgress, Grid, Box, Typography } from "@mui/material";
import {
  useChangeStatusOrderListSentToManagerMutation,
  useGetAllGroupByStoreOrderListHistoryQuery,
  useGetOrderListByIdQuery,
  useGetUserInfoOnyQuery,
  useAdminChangeStatusMutation,
  useGetRestaurantQuery,
  useGetOrderListHistoryRecordByIdQuery,
  useGetStoreQuery,
  useGetStoreItemOrderListQuery,
} from "../../../Api/attoDeskApi";
import {
  IOrderItemViewList,
  IOrderList,
  IOrderListHistoryRecord,
  IRestaurant,
  IOrderListRecordItem,
  IUserAdmin,
  IStore,
  IStoreRefItem,
} from "../../../Api/Interface/api.interface";
import { useParams } from "react-router-dom";
import {
  OrderListStatus,
  SizeOfLevelType,
  fixedPriceConfiem,
} from "../../../Core/Enum/enum";
import LogoMain from "../../../Images/logo.webp";
import TableViewIcon from "@mui/icons-material/TableView";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import dayjs, { Dayjs } from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import { useNavigate } from "react-router-dom";
import { useNotifier } from "../../../Core/Notifier";
import StatusPopup from "../../../Components/Delete/StatusPopup";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useFormik } from "formik";
import ChecklistRtlRoundedIcon from "@mui/icons-material/ChecklistRtlRounded";
import { FaEdit, FaTrash, FaExchangeAlt } from "react-icons/fa";
import { GrStatusGood } from "react-icons/gr";
import { BiSolidMessageSquareAdd } from "react-icons/bi";
import { IoPricetagsOutline } from "react-icons/io5";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const convertUnit = (unit: number) => {
  switch (unit) {
    case SizeOfLevelType.kg:
      return "kg";
    case SizeOfLevelType.small:
      return "small";
    case SizeOfLevelType.li:
      return "li";
    case SizeOfLevelType.Medium:
      return "Medium";
    case SizeOfLevelType.Bottle:
      return "Bottle";
    case SizeOfLevelType.Each:
      return "Each";
    case SizeOfLevelType.Large:
      return "Large";
    case SizeOfLevelType.case:
      return "Case";
    default:
      return "";
  }
};

const convertStatus = (unit: string): string => {
  switch (unit) {
    case "OrderListCreated":
      return "Order List Created";
    case "SentToManager":
      return "Sent To Manager";
    case "ManagerApproved":
      return "Approved";
    case "UpdatedPrice":
      return "Updated Price";
    // case "ManagerConfirmed":
    //   return "Confirmed";
    case "Processed":
      return "Processed";
    case "Completed":
      return "Completed";
    case "Rejected":
      return "Rejected";
    case "ReceiptUpdated":
      return "Receipt Updated";
    default:
      return "";
  }
};

const statusColor: Record<string, ChipProps["color"]> = {
  Created: "success",
  Modified: "warning",
  Deleted: "error",
};

const statusIcon = {
  Created: <BiSolidMessageSquareAdd color="green" size={17} />,
  Modified: <FaEdit color="orange" />,
  Deleted: <FaTrash color="red" />,
  ChangedBranch: <FaExchangeAlt color="orange" />,
  ChangedStatus: <GrStatusGood color="blue" />,
  storeChanged: <BiSolidMessageSquareAdd size={17} color="green" />,
  priceChanged: <IoPricetagsOutline size={17} color="red" />,
};

const statusMessage: Record<string, string> = {
  ChangedBranch: "Branch changed",
  ChangedStatus: "Status updated",
};

const Index = () => {
  const classes = useStyles();
  const { showErrorMessage, showMessage } = useNotifier();
  const { id: orderListHistoryId } = useParams<{ id: string }>();
  const [orderList, setOrderList] = useState<IOrderItemViewList[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10000);
  const navigate = useNavigate();
  const [coursingToStatus, setCoursingToStatus] = useState<string | undefined>(
    ""
  );
  const [open, setOpen] = useState(false);
  const [openOrderListDate, setOpenOrderListDate] = useState(false);
  const [receiptPrices, setReceiptPrices] = useState<{
    [storeId: string]: string;
  }>({});

  const {
    data: OrderListDate,
    isLoading: OrderListDateIsLoading,
    isError: OrderListDateIsError,
  } = useGetOrderListByIdQuery({
    searchText: "",
    id: String(orderListHistoryId),
  });

  const {
    data: orderListData,
    isLoading: orderListIsLoading,
    isError: orderListIsError,
    refetch: orderListRefetch,
  } = useGetAllGroupByStoreOrderListHistoryQuery({
    orderId: String(orderListHistoryId),
    searchText: "",
  });

  const {
    data: orderListRecordData,
    isLoading: orderListRecordIsLoading,
    isError: orderListRecordIsError,
    refetch: orderListRecordRefetch,
  } = useGetOrderListHistoryRecordByIdQuery({
    perentTableId: String(orderListHistoryId),
    searchText: "",
  });

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const [newStatus, { isLoading }] = useAdminChangeStatusMutation();

  const { data: restaurantData, isLoading: restauramtIsLoading } =
    useGetRestaurantQuery({
      searchText: "",
      id: "",
    });

  const { data: storeData, isLoading: storeIsLoading } = useGetStoreQuery({
    searchText: "",
  });

  const { data: storeRefData, isLoading: storeRefIsLoading } =
    useGetStoreItemOrderListQuery({
      searchText: "",
    });

  const groupedOrderList = useMemo(() => {
    return orderListData?.data ?? {};
  }, [orderListData?.data]);

  const orderListDate = useMemo(() => {
    return OrderListDate?.data as IOrderList[];
  }, [OrderListDate?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const restaurantList = useMemo(() => {
    return restaurantData?.data as IRestaurant[];
  }, [restaurantData?.data]);

  const getAllStoreList = useMemo(() => {
    return storeData?.data as IStore[];
  }, [storeData?.data]);

  const getAllStoreRefList = useMemo(() => {
    return storeRefData?.data as IStoreRefItem[];
  }, [storeRefData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const storeRefMap = useMemo(() => {
    const map = new Map();
    getAllStoreRefList?.forEach((category) => {
      map.set(category.id, `${category.referenceNo}`);
    });
    return map;
  }, [getAllStoreRefList]);

  const userMap2 = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const restaurantMap = useMemo(() => {
    const map = new Map();
    restaurantList?.forEach((category) => {
      map.set(category.id, category.restaurantsName);
    });
    return map;
  }, [restaurantList]);

  const getStoreMap = useMemo(() => {
    const map = new Map();
    getAllStoreList?.forEach((category) => {
      map.set(category.id, category.storeName);
    });
    return map;
  }, [getAllStoreList]);

  const ReDateId =
    orderListDate?.length > 0 ? orderListDate[0].orderListId : null;
  const createBy =
    orderListDate?.length > 0 ? orderListDate[0].created_by : null;
  const createAt =
    orderListDate?.length > 0 ? orderListDate[0].created_at : null;
  const orderListStatus =
    orderListDate?.length > 0 ? orderListDate[0].orderListStatus : null;
  const RestaurantsId =
    orderListDate?.length > 0 ? orderListDate[0].restaurantsId : null;

  const updatedBy =
    orderListDate?.length > 0 ? orderListDate[0].updated_by : null;
  const updatedAt =
    orderListDate?.length > 0 ? orderListDate[0].updated_at : null;

  const handleExportGroupedExcel = () => {
    const wb = XLSX.utils.book_new();

    Object.entries(groupedOrderList).forEach(([storeId, orders]) => {
      const storeName =
        storeId === undefined || storeId === null
          ? "Update Items Price to Store"
          : getStoreMap.get(Number(storeId)) || "Store Not Found";

      // const sheetData = [
      //   ["Items", "RefNo","Unit Price x Qty", "Total Price"],
      //   ...orders.map((order) => [
      //     order.variantName || "",
      //     order.productUnitPrice
      //       ? `$${order.productUnitPrice} * ${
      //           order.productTotalUnit
      //         } ${convertUnit(order.variantUnit)}`
      //       : "N/A",
      //     order.productTotalPrice ? `$${order.productTotalPrice}` : "N/A",
      //   ]),
      // ];

      const sheetData = [
        ["Items", "RefNo", "Unit Price x Qty", "Total Price"],
        ...orders.map((order) => {
          const refNo = storeRefMap.get(order.storePerentTableId);
          const displayRef = refNo && refNo !== "null" ? refNo : "";

          return [
            order.variantName || "",
            displayRef,
            order.productUnitPrice
              ? `$${order.productUnitPrice} * ${
                  order.productTotalUnit
                } ${convertUnit(order.variantUnit)}`
              : "N/A",
            order.productTotalPrice ? `$${order.productTotalPrice}` : "N/A",
          ];
        }),
      ];

      const totalPrice = orders.reduce(
        (sum, order) => sum + (Number(order.productTotalPrice) || 0),
        0
      );

      // Add an empty row then the total row
      sheetData.push([]);
      sheetData.push(["", "", "Total Price", `$${totalPrice.toFixed(2)}`]);

      const ws = XLSX.utils.aoa_to_sheet(sheetData);
      XLSX.utils.book_append_sheet(wb, ws, storeName.slice(0, 31));
    });

    const today = dayjs();
    const formattedDate = today.format("MMM, DD YYYY (dddd)");
    const filename = `Grouped_Store_Orders_${formattedDate}`;
    XLSX.writeFile(wb, `${filename}.xlsx`);
  };

  const handleExportGroupedPDF = () => {
    const doc = new jsPDF("l", "mm", "a4");
    const imageUrl = LogoMain;
    const pageWidth = doc.internal.pageSize.width;

    const imgWidth = 50;
    const imgHeight = 12;
    const imgX = 10;
    const imgY = 10;

    const img = new Image();
    img.src = imageUrl;
    doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);

    const rightTextX = pageWidth - 15;
    let rightTextY = 12;

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    doc.text(`${ReDateId}`, rightTextX, rightTextY, { align: "right" });
    rightTextY += 4;

    doc.text(
      `${restaurantMap.get(RestaurantsId) || ""}`,
      rightTextX,
      rightTextY,
      {
        align: "right",
      }
    );

    let currentY = 35;

    Object.entries(groupedOrderList).forEach(([storeId, orders], idx) => {
      const storeName =
        storeId === undefined || storeId === null
          ? "Update Items Price to Store"
          : getStoreMap.get(Number(storeId)) || "Store Not Found";

      // const tableData = orders.map((order) => [
      //   order.variantName || "",
      //   order.productUnitPrice
      //     ? `$${order.productUnitPrice} * ${
      //         order.productTotalUnit
      //       } ${convertUnit(order.variantUnit)}`
      //     : "N/A",
      //   order.productTotalPrice ? `$${order.productTotalPrice}` : "N/A",
      // ]);

      const tableData = orders.map((order) => {
        const refNo = storeRefMap.get(order.storePerentTableId);
        const displayRef = refNo && refNo !== "null" ? refNo : "";

        return [
          order.variantName || "",
          displayRef,
          order.productUnitPrice
            ? `$${order.productUnitPrice} * ${
                order.productTotalUnit
              } ${convertUnit(order.variantUnit)}`
            : "N/A",
          order.productTotalPrice ? `$${order.productTotalPrice}` : "N/A",
        ];
      });

      const totalPrice = orders.reduce(
        (sum, order) => sum + (Number(order.productTotalPrice) || 0),
        0
      );

      // Store name
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      doc.text(storeName, 12, currentY);

      currentY += 5;

      (doc as any).autoTable({
        head: [["Items", "RefNo", "Unit Price x Qty", "Total Price"]],
        body: tableData,
        startY: currentY,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [200, 200, 200] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
        didDrawPage: (data: any) => {
          currentY = data.cursor.y + 2;
        },
      });

      // Add total row
      doc.setFontSize(10);
      doc.text(
        `Total Price: $${totalPrice.toFixed(2)}`,
        pageWidth - 60,
        currentY + 5
      );

      currentY += 15; // Add space after total
    });

    const today = dayjs();
    const formattedDate = today.format("MMM, DD YYYY (dddd)");
    const filename = `Grouped_Store_Orders_${formattedDate}.pdf`;
    doc.save(filename);
  };

  const handleOpenStatusPopup = () => {
    setCoursingToStatus(String(orderListHistoryId));
    setOpen(true);
  };

  const handleCloseStatusPopup = () => {
    setCoursingToStatus(undefined);
    setOpen(false);
  };

  const handleOpenDialogGenerate = () => {
    setOpenOrderListDate(true);
  };

  const handleCloseDialogGenerate = () => {
    setOpenOrderListDate(false);
  };

  const formik = useFormik({
    initialValues: {
      id: "",
      status: "Processed",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          id: String(orderListHistoryId),
          status: values.status,
        };

        const addCompanyResponse = await newStatus(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          resetForm();
          setOpenOrderListDate(false);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const [changeStatus] = useChangeStatusOrderListSentToManagerMutation();

  const handleChangeStatus = async (id: string) => {
    try {
      const response = await changeStatus(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpen(false);
        navigate("/order/list");
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to change status");
    }
  };

  const formValid = useMemo(() => {
    return formik.values.status !== "" && formik.values.status !== undefined;
  }, [formik]);

  const coursings: IOrderListHistoryRecord[] = Array.isArray(
    orderListRecordData?.data
  )
    ? (orderListRecordData?.data as IOrderListHistoryRecord[])
    : [];

  if (
    orderListIsLoading ||
    OrderListDateIsLoading ||
    restauramtIsLoading ||
    storeIsLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item lg={8} md={6} sm={12} xs={12}>
        <Card className={classes.orderListLeftCardView}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ padding: 2, borderBottom: 4 }}
            className={classes.orderListLeftHeader}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >
                <Grid item>
                  <Button
                    startIcon={<TableViewIcon />}
                    className={classes.ordeListButton}
                    onClick={handleExportGroupedExcel}
                  >
                    Excel
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    startIcon={<LocalPrintshopSharpIcon />}
                    className={classes.ordeListButton}
                    onClick={handleExportGroupedPDF}
                  >
                    pdf
                  </Button>
                </Grid>
                {orderListStatus !== "Processed" &&
                  orderListStatus !== "ReceiptUpdated" && (
                    <Grid item>
                      <Button
                        startIcon={<CheckCircleOutlineIcon />}
                        className={classes.ordeListConfirmButton}
                        onClick={() => {
                          if (orderListStatus === "OrderListCreated") {
                            handleOpenStatusPopup();
                          } else {
                            handleOpenDialogGenerate();
                          }
                        }}
                      >
                        Confirm
                      </Button>
                    </Grid>
                  )}

                {(orderListStatus === "OrderListCreated" ||
                  orderListStatus === "SentToManager") && (
                  <Grid item>
                    <Button
                      startIcon={<EditSharpIcon />}
                      className={classes.ordeListEditButton}
                      onClick={() => {
                        const path =
                          orderListStatus === "OrderListCreated"
                            ? `/order/list/edit/${orderListHistoryId}`
                            : `/order/list/sentToManager/edit/${orderListHistoryId}`;

                        navigate(path);
                      }}
                    >
                      Edit
                    </Button>
                  </Grid>
                )}
                {orderListStatus === "ManagerApproved" && (
                  <Grid item>
                    <Button
                      startIcon={<ChecklistRtlRoundedIcon />}
                      className={classes.ordeListConfirmButton}
                      onClick={() => {
                        navigate(
                          `/order/list/price/admin/edit/${orderListHistoryId}`
                        );
                      }}
                    >
                      Price Check List
                    </Button>
                  </Grid>
                )}
                {orderListStatus === "UpdatedPrice" && (
                  <Grid item>
                    <Button
                      startIcon={<EditSharpIcon />}
                      className={classes.ordeListEditButton}
                      onClick={() => {
                        navigate(
                          `/order/list/set/price/edit/${orderListHistoryId}`
                        );
                      }}
                    >
                      Edit Price
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Box
            sx={{
              height: "90vh",
              overflow: "auto",
              padding: "2px",
              "&::-webkit-scrollbar": {
                width: "4px",
              },
              "&::-webkit-scrollbar-track": {
                background: "#eeeeee",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#eeeeee",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "#eeeeee",
              },
            }}
          >
            <Grid
              container
              spacing={2}
              my={2}
              px={1}
              sx={{ padding: 2 }}
              className={classes.orderListLeftHeader}
            >
              <Grid item lg={4} md={6} sm={6} xs={6} mb={2}>
                <Grid container>
                  <img
                    src={LogoMain}
                    alt="AttoDesk Login"
                    style={{
                      width: "200px",
                      height: "60px",
                      display: "block",
                    }}
                  />
                </Grid>
              </Grid>

              <Grid item lg={8} md={6} sm={6} xs={6} mb={2}>
                <Typography
                  variant="subtitle1"
                  textAlign={"right"}
                  className={classes.OLCardTitle256}
                >
                  Order List : {ReDateId}
                </Typography>
                {coursings.length === 0 ? (
                  <Typography
                    textAlign={"right"}
                    className={classes.OLTypograpyNormal}
                  >
                    {"Created By : "}
                    {userMap.get(createBy) || ""}
                  </Typography>
                ) : (
                  <Typography
                    textAlign={"right"}
                    className={classes.OLTypograpyNormal}
                  >
                    {"Updated By : "}
                    {userMap.get(updatedBy) || ""}
                  </Typography>
                )}
                {coursings.length === 0 ? (
                  <Typography
                    textAlign={"right"}
                    className={classes.OLTypograpyNormal}
                  >
                    {"Created At : "}
                    {dayjs(createAt).format("MMM-D, YYYY hh:mm A") || ""}
                  </Typography>
                ) : (
                  <Typography
                    textAlign={"right"}
                    className={classes.OLTypograpyNormal}
                  >
                    {"Updated At : "}
                    {dayjs(updatedAt).format("MMM-D, YYYY hh:mm A") || ""}
                  </Typography>
                )}
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12} mb={2}>
                <Typography
                  textAlign={"right"}
                  className={classes.OLLeftHeading}
                >
                  {convertStatus(orderListStatus || "")}
                </Typography>
                <Typography
                  textAlign={"right"}
                  className={classes.OLLeftHeading}
                >
                  {/* {"Branch : "} */}
                  {restaurantMap.get(RestaurantsId) || ""}
                </Typography>
              </Grid>
              <>
                {orderListIsLoading ? (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      height="10vh"
                    >
                      <CircularProgress />
                    </Box>
                  </Grid>
                ) : orderListIsError ? (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography
                      textAlign={"center"}
                      className={classes.leftORTypo}
                    >
                      Some thing went to wrong
                    </Typography>
                  </Grid>
                ) : Object.keys(groupedOrderList).length === 0 ? (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography
                      textAlign={"center"}
                      className={classes.leftORTypo}
                    >
                      No data available
                    </Typography>
                  </Grid>
                ) : (
                  Object.entries(groupedOrderList).map(([storeId, orders]) => {
                    const storeName =
                      storeId === undefined || storeId === null
                        ? "Update Items Price to Store"
                        : getStoreMap.get(Number(storeId)) || "Store Not Found";

                    const totalPrice = orders.reduce(
                      (sum, order) =>
                        sum + (Number(order.productTotalPrice) || 0),
                      0
                    );

                    const receiptInput = receiptPrices[storeId] || "";
                    const isDifferent =
                      receiptInput !== "" &&
                      parseFloat(receiptInput) !== totalPrice;

                    return (
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        key={storeId}
                        pb={2}
                      >
                        <Card
                          sx={{
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            borderRadius: 3,
                            boxShadow: "none",
                            border: `1px solid #d8dfe7`,
                            transition: "0.3s ease-in-out",
                            "&:hover": {
                              backgroundColor: "#ffffff",
                              borderRadius: "10px",
                              border: "0.5px solid #ffffff",
                              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                            },
                          }}
                        >
                          <CardContent
                            sx={{
                              flex: 1,
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Typography
                              fontWeight="bold"
                              gutterBottom
                              className={classes.orderLsitHeadingTypoView}
                              style={{
                                fontWeight: "bold",
                                color: "#007bff",
                              }}
                            >
                              {storeName}
                            </Typography>

                            <List sx={{ flexGrow: 1 }}>
                              {orders.map((order, index) => (
                                <React.Fragment key={order.id}>
                                  <ListItem
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      px: 2,
                                      py: 1,
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontWeight: "bold",
                                        color: "#1a202c",
                                        flex: 1,
                                        textAlign: "left",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        window.open(
                                          `/variant/view/${order.productId}`,
                                          "_blank"
                                        )
                                      }
                                    >
                                      {order.variantName}{" "}
                                      {storeRefMap.get(
                                        order.storePerentTableId
                                      ) !== "null" && (
                                        <span style={{ color: "#718096" }}>
                                          (Ref:{" "}
                                          {storeRefMap.get(
                                            order.storePerentTableId
                                          )}
                                          )
                                        </span>
                                      )}
                                    </Typography>

                                    <Typography
                                      sx={{
                                        color: "#28a745",
                                        fontWeight: "bold",
                                        flex: 1,
                                        textAlign: "center",
                                      }}
                                    >
                                      {order.productUnitPrice
                                        ? `$${order.productUnitPrice}`
                                        : "N/A"}
                                      {" * "}
                                      {order.productTotalUnit}{" "}
                                      {convertUnit(order.variantUnit)}
                                    </Typography>

                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: "#555",
                                        flex: 1,
                                        textAlign: "right",
                                      }}
                                    >
                                      {order.productTotalPrice
                                        ? `$${order.productTotalPrice}`
                                        : "N/A"}
                                    </Typography>
                                  </ListItem>

                                  <Divider />
                                </React.Fragment>
                              ))}
                              {orderListStatus === "UpdatedPrice" && (
                                <ListItem
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    px: 2,
                                    py: 1,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      backgroundColor: "#f0f4f8",
                                      padding: "8px",
                                      borderRadius: "8px",
                                      marginTop: "8px",
                                      border: "1px solid #ccc",
                                      minWidth: 300,
                                    }}
                                  >
                                    <Typography
                                      variant="body1"
                                      style={{
                                        fontWeight: "bold",
                                        color: "#333",
                                      }}
                                    >
                                      {"Total Price : "}
                                    </Typography>

                                    <Typography
                                      variant="body1"
                                      style={{
                                        fontWeight: "bold",
                                        color: "#007bff",
                                      }}
                                    >
                                      {`$${totalPrice.toFixed(2)}`}
                                    </Typography>
                                  </div>
                                </ListItem>
                              )}
                              {(orderListStatus === "Processed" ||
                                orderListStatus === "ReceiptUpdated") && (
                                <ListItem
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    px: 2,
                                    py: 2,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      backgroundColor: "#f9fafb",
                                      border: "1px solid #d1d5db",
                                      borderRadius: 2,
                                      padding: 2,
                                      display: "flex",
                                      flexDirection: "column",
                                      minWidth: 320,
                                      gap: 1,
                                    }}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      sx={{
                                        fontWeight: 600,
                                        color: "#374151",
                                      }}
                                    >
                                      Enter Receipt Total Amount
                                    </Typography>

                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        gap: 2,
                                      }}
                                    >
                                      <TextField
                                        variant="outlined"
                                        placeholder="Receipt Price"
                                        type="number"
                                        size="small"
                                        value={receiptInput}
                                        onChange={(e) =>
                                          setReceiptPrices((prev) => ({
                                            ...prev,
                                            [storeId]: e.target.value,
                                          }))
                                        }
                                        sx={{ flex: 1 }}
                                      />

                                      <Typography
                                        variant="body2"
                                        sx={{
                                          fontWeight: "bold",
                                          color: "#007bff",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        Total: ${totalPrice.toFixed(2)}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </ListItem>
                              )}
                            </List>

                            {isDifferent &&
                              (orderListStatus === "Processed" ||
                                orderListStatus === "ReceiptUpdated") && (
                                <Grid
                                  container
                                  spacing={1}
                                  justifyContent="flex-end"
                                  sx={{ display: "flex", mt: 5 }}
                                >
                                  <Grid item>
                                    <Button
                                      startIcon={<CloudUploadIcon />}
                                      className={classes.ordeListConfirmButton}
                                      onClick={() => {
                                        navigate(
                                          `/order/list/update/price/orderlist/${orderListHistoryId}/store/${storeId}`
                                        );
                                      }}
                                    >
                                      Upload
                                    </Button>
                                  </Grid>
                                </Grid>
                              )}
                          </CardContent>
                        </Card>
                      </Grid>
                    );
                  })
                )}
              </>
            </Grid>
          </Box>

          {coursingToStatus && (
            <StatusPopup
              open={open}
              handleCloseDelete={handleCloseStatusPopup}
              onConfirm={async () => {
                await handleChangeStatus(String(orderListHistoryId).toString());
              }}
              title="Confirm Status Change"
              content={`Are you sure you want to change the status to "Manager Approval Pending"? 
            Once updated, this action cannot be undone. 
            Order ID: ${ReDateId}`}
            />
          )}

          <Dialog
            open={openOrderListDate}
            onClose={handleCloseDialogGenerate}
            sx={{ padding: 5, minWidth: 450 }}
          >
            <Grid className={classes.Dialog}>
              <form onSubmit={formik.handleSubmit}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    pt={2}
                    alignContent={"center"}
                  >
                    <Typography className={classes.cardTitle}>
                      Confirm Action
                    </Typography>
                  </Grid>
                </Grid>
                <DialogContent>
                  <DialogContentText sx={{ pt: 3 }}>Status</DialogContentText>
                  <Grid container alignItems="center">
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={1}>
                      <TextField
                        select
                        size="small"
                        className={classes.textField}
                        SelectProps={{
                          native: false,
                        }}
                        defaultValue=""
                        InputLabelProps={{ shrink: true }}
                        {...formik.getFieldProps("status")}
                      >
                        <MenuItem value="" disabled>
                          Select some option
                        </MenuItem>

                        {Object.entries(fixedPriceConfiem).map(
                          ([key, value], index) => (
                            <MenuItem key={index} value={value}>
                              {convertStatus(key)}
                            </MenuItem>
                          )
                        )}
                      </TextField>
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="outlined"
                    startIcon={<CloseIcon />}
                    className={classes.addButton}
                    onClick={handleCloseDialogGenerate}
                  >
                    Cancel
                  </Button>
                  <Box m={0.5}></Box>

                  <Button
                    variant="contained"
                    startIcon={<CheckCircleOutlineIcon />}
                    className={classes.addButton}
                    onClick={() => formik.handleSubmit()}
                    disabled={!formValid || isLoading}
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </form>
            </Grid>
          </Dialog>
        </Card>
      </Grid>

      <Grid item lg={4} md={6} sm={12} xs={12}>
        <Grid container spacing={1}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.orderListRightCard2}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ padding: 2, borderBottom: 4 }}
                className={classes.oLRightHeader}
              >
                <Grid
                  item
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-start"
                    sx={{ display: "flex" }}
                  >
                    <Grid item>
                      <Typography className={classes.orderLsitHeadingTypo}>
                        History
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}></Grid>
            </Card>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Box
              sx={{
                height: "100vh",
                overflow: "auto",
                padding: "2px",
                "&::-webkit-scrollbar": {
                  width: "4px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#eeeeee",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#eeeeee",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#eeeeee",
                },
              }}
            >
              <Stack spacing={2}>
                {coursings.map((order, index) => {
                  if (
                    order.order_list_record.length === 0 &&
                    order.activeStatus === "NoChange"
                  )
                    return null;

                  const isLast = index === coursings.length - 1;
                  const userId = isLast ? order.created_by : order.updated_by;
                  const userName = userMap.get(userId) || "";

                  return (
                    <Card
                      key={order.id}
                      variant="outlined"
                      className={classes.orderListRightCard2}
                    >
                      <CardContent>
                        <Stack spacing={1} mb={2}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            {/* <FaRegCalendarAlt style={{ color: "#1976d2", fontSize: 18 }} /> */}
                            <Typography variant="h6" fontWeight={600}>
                              {dayjs(order.order_List_created_at).format(
                                "MMM D, YYYY h:mm A"
                              )}
                            </Typography>
                          </Stack>

                          <Stack
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            spacing={1}
                            flexWrap="wrap"
                          >
                            <Typography
                              variant="body2"
                              // className={classes.orderLsitHeadingTypoColor}
                              className={`${
                                classes.orderLsitHeadingTypoColor
                              } ${
                                order.activeStatus === "ChangedBranch"
                                  ? classes.changedBranchColor
                                  : ""
                              }`}
                            >
                              {restaurantMap.get(order.restaurantsId) || ""}
                            </Typography>

                            <Typography
                              variant="body2"
                              className={classes.orderLsitHeadingTypoColor}
                            >
                              |
                            </Typography>

                            <Typography
                              variant="body2"
                              // className={classes.orderLsitHeadingTypoColor}
                              className={`${
                                classes.orderLsitHeadingTypoColor
                              } ${
                                order.activeStatus === "ChangedStatus"
                                  ? classes.changedStatusColor
                                  : ""
                              }`}
                            >
                              {convertStatus(order.orderListStatus || "") || ""}
                            </Typography>

                            <Typography
                              variant="body2"
                              className={classes.orderLsitHeadingTypoColor}
                            >
                              |
                            </Typography>

                            <Typography
                              variant="body2"
                              className={classes.orderLsitHeadingTypoColor}
                            >
                              {userName}
                            </Typography>
                          </Stack>
                        </Stack>
                        {order.activeStatus !== "NoChange" && (
                          <>
                            {/* <Divider sx={{ mb: 2 }} /> */}
                            <Stack spacing={1} mb={2}>
                              <Stack
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                spacing={1}
                                flexWrap="wrap"
                              >
                                {
                                  statusIcon[
                                    order.activeStatus as keyof typeof statusIcon
                                  ]
                                }

                                <Typography
                                  fontWeight={600}
                                  className={classes.rightORTypoColor}
                                >
                                  <strong>
                                    {statusMessage[
                                      order.activeStatus as keyof typeof statusMessage
                                    ] || "Unknown status"}
                                  </strong>
                                </Typography>
                              </Stack>
                            </Stack>
                          </>
                        )}
                        {order.order_list_record.length > 0 && (
                          <Divider sx={{ mb: 2 }} />
                        )}
                        {order.orderListStatus === "UpdatedPrice" ||
                        order.orderListStatus === "ReceiptUpdated" ||
                        order.orderListStatus === "Processed"
                          ? // Group by storeId
                            Object.entries(
                              order.order_list_record.reduce((acc, item) => {
                                const key = item.storeId || "unknown";
                                if (!acc[key]) acc[key] = [];
                                acc[key].push(item);
                                return acc;
                              }, {} as Record<string, typeof order.order_list_record>)
                            ).map(([storeId, items]) => {
                              const storeTotal = items.reduce((sum, i) => {
                                return sum + (Number(i.productTotalPrice) || 0);
                              }, 0);

                              return (
                                <Box key={storeId} mb={3}>
                                  {storeId !== "unknown" && (
                                    <Stack
                                      direction="row"
                                      alignItems="center"
                                      justifyContent="space-between"
                                      sx={{ mb: 1 }}
                                    >
                                      <Typography variant="h5" color="primary">
                                        🏠{" "}
                                        {getStoreMap.get(Number(storeId)) ||
                                          "Unknown Store"}
                                      </Typography>
                                    </Stack>
                                  )}

                                  {items.map((item) => (
                                    <Box key={item.id} mb={2} ml={2}>
                                      <Stack
                                        direction="row"
                                        alignItems="center"
                                        justifyContent="space-between"
                                      >
                                        {item.variantName.length > 20 ? (
                                          <Tooltip
                                            title={
                                              <Typography
                                                variant="body2"
                                                sx={{ whiteSpace: "pre-line" }}
                                              >
                                                <strong>
                                                  {item.variantName}
                                                </strong>
                                              </Typography>
                                            }
                                          >
                                            <Stack
                                              direction="row"
                                              alignItems="center"
                                              spacing={1}
                                            >
                                              {
                                                statusIcon[
                                                  item.activeStatus as keyof typeof statusIcon
                                                ]
                                              }
                                              <Typography
                                                fontWeight={600}
                                                className={
                                                  classes.rightORTypoColor
                                                }
                                                onClick={() =>
                                                  window.open(
                                                    `/variant/view/${item.productId}`,
                                                    "_blank"
                                                  )
                                                }
                                                sx={{
                                                  cursor: "pointer",
                                                }}
                                              >
                                                {`${item.variantName.slice(
                                                  0,
                                                  20
                                                )}...`}
                                              </Typography>
                                            </Stack>
                                          </Tooltip>
                                        ) : (
                                          <Stack
                                            direction="row"
                                            alignItems="center"
                                            spacing={1}
                                          >
                                            {
                                              statusIcon[
                                                item.activeStatus as keyof typeof statusIcon
                                              ]
                                            }
                                            <Typography
                                              fontWeight={600}
                                              className={
                                                classes.rightORTypoColor
                                              }
                                              onClick={() =>
                                                window.open(
                                                  `/variant/view/${item.productId}`,
                                                  "_blank"
                                                )
                                              }
                                              sx={{
                                                cursor: "pointer",
                                              }}
                                            >
                                              {item.variantName}
                                            </Typography>
                                          </Stack>
                                        )}

                                        <Typography
                                          sx={{
                                            fontWeight: "bold",
                                            flex: 1,
                                            textAlign: "right",
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            gap: "4px",
                                            flexWrap: "wrap",
                                          }}
                                        >
                                          <Box
                                            component="span"
                                            color={
                                              item.activeStatus ===
                                              "priceChanged"
                                                ? "red"
                                                : "#28a745"
                                            }
                                          >
                                            {item.productUnitPrice
                                              ? `$${Number(
                                                  item.productUnitPrice
                                                ).toLocaleString()}`
                                              : "N/A"}
                                          </Box>
                                          <Box component="span" color="#28a745">
                                            * {item.productTotalUnit}
                                          </Box>
                                          <Box component="span" color="#28a745">
                                            {convertUnit(item.variantUnit)}
                                          </Box>
                                          <Box component="span">=</Box>
                                          <Box component="span">
                                            {item.productTotalPrice
                                              ? `$${Number(
                                                  item.productTotalPrice
                                                ).toLocaleString()}`
                                              : "N/A"}
                                          </Box>
                                        </Typography>
                                      </Stack>
                                    </Box>
                                  ))}
                                  {/* {storeId !== "unknown" && (
                                    <Stack
                                      direction="row"
                                      alignItems="right"
                                      justifyContent="right"
                                      sx={{ mb: 1 }}
                                    >
                                      <Typography
                                        variant="h5"
                                        color="primary"
                                        textAlign={"right"}
                                      >
                                        Total: ${storeTotal.toFixed(2)}
                                      </Typography>
                                    </Stack>
                                  )} */}
                                </Box>
                              );
                            })
                          : // Render normally (no price or grouping)
                            order.order_list_record.map((item) => (
                              <Box key={item.id} mb={2}>
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  justifyContent="space-between"
                                >
                                  {item.variantName.length > 20 ? (
                                    <Tooltip
                                      title={
                                        <Typography
                                          variant="body2"
                                          sx={{ whiteSpace: "pre-line" }}
                                        >
                                          <strong>{item.variantName}</strong>
                                        </Typography>
                                      }
                                    >
                                      <Stack
                                        direction="row"
                                        alignItems="center"
                                        spacing={1}
                                      >
                                        {
                                          statusIcon[
                                            item.activeStatus as keyof typeof statusIcon
                                          ]
                                        }
                                        <Typography
                                          fontWeight={600}
                                          className={classes.rightORTypoColor}
                                          onClick={() =>
                                            window.open(
                                              `/variant/view/${item.productId}`,
                                              "_blank"
                                            )
                                          }
                                          sx={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          {`${item.variantName.slice(
                                            0,
                                            20
                                          )}...`}
                                        </Typography>
                                      </Stack>
                                    </Tooltip>
                                  ) : (
                                    <Stack
                                      direction="row"
                                      alignItems="center"
                                      spacing={1}
                                    >
                                      {
                                        statusIcon[
                                          item.activeStatus as keyof typeof statusIcon
                                        ]
                                      }
                                      <Typography
                                        fontWeight={600}
                                        className={classes.rightORTypoColor}
                                        onClick={() =>
                                          window.open(
                                            `/variant/view/${item.productId}`,
                                            "_blank"
                                          )
                                        }
                                        sx={{
                                          cursor: "pointer",
                                        }}
                                      >
                                        {item.variantName}
                                      </Typography>
                                    </Stack>
                                  )}

                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    {item.productTotalUnit}{" "}
                                    {convertUnit(item.variantUnit)}
                                  </Typography>
                                </Stack>

                                {item.remark && item.remark.length > 100 ? (
                                  <Tooltip
                                    title={
                                      <Typography
                                        variant="body2"
                                        sx={{ whiteSpace: "pre-line" }}
                                      >
                                        <strong>💬 {item.remark}</strong>
                                      </Typography>
                                    }
                                  >
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                      sx={{ mt: 0.5, pl: 4 }}
                                    >
                                      💬 {`${item.remark.slice(0, 100)}...`}
                                    </Typography>
                                  </Tooltip>
                                ) : (
                                  item.remark && (
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                      sx={{ mt: 0.5, pl: 4 }}
                                    >
                                      💬 {item.remark}
                                    </Typography>
                                  )
                                )}
                              </Box>
                            ))}
                      </CardContent>
                    </Card>
                  );
                })}
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Index;
